module.exports = "/_next/static/images/ce06d76b631295fdeea5a4bed4d43fa0-bubble-gum-woman-square@md-1x.jpg";